<div class="options-executed-orders">
	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'md',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'optionsOrders.empty',
		}"
		[items]="ordersResponse()?.orders ?? []"
		[isLoading]="isLoading()"
	>
		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.tickerCompany',
				column: columnsOptionsExecutedOrdersEnum.tickerCompany,
				minWidthPx: 200,
				maxWidthPx: 230,
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					<span class="text">{{ item?.option_ticker }}</span>
					<span class="text">{{ item?.option_strike | price }}</span>
					<span
						class="text"
						highlight
						[isPositive]="item?.option_type === optionTypeEnum.CALL"
						[isNegative]="item?.option_type === optionTypeEnum.PUT"
					>
						{{ item?.option_type | uppercase }}
					</span>
					<span class="text">{{ item?.option_date | date: 'dd.MM.yyyy' }}</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.operation',
				column: columnsOptionsExecutedOrdersEnum.operation,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isPositive]="item.side === orderSideEnum.BUY"
					[isNegative]="item.side === orderSideEnum.SELL"
				>
					{{ 'optionsOrders.side.' + item.side | translate }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.quantity',
				column: columnsOptionsExecutedOrdersEnum.quantity,
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.qty | quantity }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.sum',
				column: columnsOptionsExecutedOrdersEnum.sum,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ getOptionSum(item) | price }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.profitability',
				column: columnsOptionsExecutedOrdersEnum.profitability,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				@if (item.is_close_position) {
					<div class="column">
						<span
							secret
							[isSecret]="isSecret()"
							[secretCount]="4"
							class="text"
							highlight
							[isNegative]="(item?.profit_cash ?? 0) < 0"
							[isPositive]="(item?.profit_cash ?? 0) > 0"
							[isNeutral]="!item?.profit_cash"
						>
							{{ item?.profit_cash | price }}
						</span>
						<span
							class="text"
							highlight
							[isNegative]="(item?.profit_percent ?? 0) < 0"
							[isPositive]="(item?.profit_percent ?? 0) > 0"
							[isNeutral]="!item?.profit_percent"
						>
							{{ item?.profit_percent | profit: 'percent' }}
						</span>
					</div>
				} @else {
					<span class="text">-</span>
				}
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.dateTime',
				column: columnsOptionsExecutedOrdersEnum.dateTime,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span class="text">{{ item.filled_at | date: 'dd.MM.yyyy' }}</span>
					<span class="subtext">{{ item.filled_at | date: 'HH:mm:ss' }}</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-options-executed-orders-actions [option]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'optionsOrders.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							>{{ (ordersResponse()?.orders ?? []).length | quantity }}</span
						>
					</div>

					<app-pagination
						[isLoading]="isLoading()"
						[total]="ordersResponse()?.count ?? 0"
						[pageIndex]="ordersParams()?.page ?? 1"
						(pageChange)="onChangePage($event)"
					/>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
